





































import Vue from 'vue';
import Component from 'vue-class-component';
import { Mutation, State, Getter, Action } from 'vuex-class';

import {  IPaymentStatus } from '../../models';
import { BaseDetail } from '../Base/BaseDetail';

const namespace = 'paymentStatus';
const ns = { namespace };

@Component
export default class PaymentStatusDetail extends BaseDetail<
  IPaymentStatus
> {
  namespace = namespace;
  @State('entities', ns) entities: Record<string, IPaymentStatus>;
  @Action('createEntity', ns) createEntity: any;
  @Action('getEntity', ns) getEntity: any;
  @Action('updateEntity', ns) updateEntity: any;
  @Action('deleteEntity', ns) deleteEntity: any;
  mounted() {
    this.loadEntity();
  }
}
